/* unplugin-vue-components disabled */import { render } from "./CommunityEdit.vue?vue&type=template&id=86d256ee"
import script from "./CommunityEdit.vue?vue&type=script&lang=js"
export * from "./CommunityEdit.vue?vue&type=script&lang=js"

import "./CommunityEdit.vue?vue&type=style&index=0&id=86d256ee&lang=css"

import exportComponent from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__